<div class="select-account-type">
  <div class="select-account-type__content">
    <div class="select-account-type__body">
      <div class="select-account-type__header">
        <h1 class="select-account-type__title">Que bom ter você com a gente!</h1>
        <p class="select-account-type__subtitle">
          Selecione o tipo de conta que deseja criar para começar.
        </p>
      </div>

      <div class="select-account-type__cards">
        <button
          type="button"
          class="select-account-type__card"
          [class.select-account-type__card--selected]="selectedType() === 'personal'"
          (click)="selectType('personal')"
        >
          @if (selectedType() === 'personal') {
            <aprova-icon
              name="check-circle-solid"
              size="24px"
              color="var(--Icon-Aprova-Primary)"
              class="select-account-type__card__check"
            />
          }
          <div class="select-account-type__card__icon select-account-type__card__icon--personal">
            <aprova-icon
              name="user-outline"
              size="md"
              [color]="selectedType() === 'personal' ? 'var(--Text-Aprova-Primary)' : 'var(--Icon-Neutral-Primary)'"
            />
          </div>
          <div class="select-account-type__card__text">
            <p class="select-account-type__card__title">Pessoa física</p>
            <p class="select-account-type__card__description">
              Conta individual para requerentes
            </p>
          </div>
        </button>

        @if (allowUseCnpj()) {
          <button
            type="button"
            class="select-account-type__card"
            [class.select-account-type__card--selected]="selectedType() === 'business'"
            (click)="selectType('business')"
          >
            @if (selectedType() === 'business') {
              <aprova-icon
                name="check-circle-solid"
                size="24px"
                color="var(--Icon-Aprova-Primary)"
                class="select-account-type__card__check"
              />
            }
            <div class="select-account-type__card__icon select-account-type__card__icon--business">
              <aprova-icon
                name="office-building-solid"
                size="md"
                [color]="selectedType() === 'business' ? 'var(--Text-Aprova-Primary)' : 'var(--Icon-Neutral-Primary)'"
              />
            </div>
            <div class="select-account-type__card__text">
              <p class="select-account-type__card__title">Pessoa Jurídica</p>
              <p class="select-account-type__card__description">
                Conta empresarial com CNPJ
              </p>
            </div>
          </button>
        }
      </div>
    </div>

    <div class="select-account-type__actions">
      <button
        type="button"
        class="select-account-type__btn select-account-type__btn--secondary"
        (click)="goBack()"
      >
        Voltar
      </button>
      <button
        type="button"
        class="select-account-type__btn select-account-type__btn--primary"
        [disabled]="!selectedType()"
        (click)="continue()"
      >
        Continuar
      </button>
    </div>

    <div class="select-account-type__info">
      <aprova-icon name="information-circle-solid" size="lg" color="var(--Text-Aprova-Primary)" />
      <p>
        Se você trabalha nesta organização e precisa de
        <strong>conta interna</strong>, solicite ao administrador do sistema que
        lhe envie um convite para realizar o seu cadastro. Em caso de dúvidas,
        entre em contato com o nosso suporte.
      </p>
    </div>
  </div>
</div>
